module.exports = __webpack_public_path__ + "static/media/chef.ec78e8e8.png";